module.exports = __webpack_public_path__ + "static/Montserrat-Italic-761177c558bb3a0084aa85704315b990.ttf";